import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { SubCategoriesServiceProxy, CreateOrEditSubCategoryDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditSubCategoryModal',
    templateUrl: './create-or-edit-subCategory-modal.component.html',
    standalone: false,
})
export class CreateOrEditSubCategoryModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    subCategory: CreateOrEditSubCategoryDto = new CreateOrEditSubCategoryDto();

    constructor(
        injector: Injector,
        private _subCategoriesServiceProxy: SubCategoriesServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(subCategoryId?: number): void {
        if (!subCategoryId) {
            this.subCategory = new CreateOrEditSubCategoryDto();
            this.subCategory.id = subCategoryId;

            this.active = true;
            this.modal.show();
        } else {
            this._subCategoriesServiceProxy.getSubCategoryForEdit(subCategoryId).subscribe((result) => {
                this.subCategory = result.subCategory;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._subCategoriesServiceProxy
            .createOrEdit(this.subCategory)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
